<template>
  <img :src="iconPath" width="20px" height="22px" :class="iconClass" :alt="alt"/>
</template>

<script>
export default {
  name: 'dropdown-image',
  props: {
    otherIconPath: String,
    iconName: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ''
    },
    iconClass: String
  },

  computed: {
    iconPath() {
      return this.otherIconPath
        ? this.otherIconPath + this.iconName
        : require('@/common/assets/img/icons/menuVisitor/' + this.iconName)
    }
  }
}
</script>
